// extracted by mini-css-extract-plugin
export default {"root":"Header_root__LowL6","titleContainer":"Header_titleContainer__U6b45","title":"Header_title__RfLy4","listingsResultLabel":"Header_listingsResultLabel__QtxxW"};